
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/site/[siteId]",
      function () {
        return require("private-next-pages/store/site/[siteId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/site/[siteId]"])
      });
    }
  